import { Divider, Grid, Typography } from '@mui/material';
import * as React from 'react';

import muiStyles from './styles';
import { BalanceTileProps, WalletTotalBalanceTileProps } from './types';

const BalanceTile = (props: BalanceTileProps) => {
    const {
        title,
        balance,
        bottomDescription
    } = props;

    const classes = muiStyles(props);

    return (
        <Grid
            className={classes.tileContainer}
            item
            xs='auto'
        >
            <Typography className={classes.tileText}>{title}</Typography>
            <Typography className={`${classes.tileText} ${classes.tileBalanceText}`}>{balance}</Typography>
            <Typography className={classes.tileText}>{bottomDescription ?? ''}</Typography>
        </Grid>
    );
};

const WalletTotalBalanceTile = (props: WalletTotalBalanceTileProps) => {
    const { stats } = props;

    const classes = muiStyles(props);

    return (
        <Grid
            className={classes.gridContainer}
            container
            direction='row'
            spacing={0}
            wrap='nowrap'
        >
            {
                stats.map((stat, i) => (
                    <Grid
                        className={classes.tileColumnContainer}
                        container
                        data-testid='total-balance-column'
                        item
                        key={`row-detail-${i}`}
                    >
                        <BalanceTile
                            balance={stat.availableBalance}
                            bottomDescription={stat.availableBottomDescription}
                            title={stat.availableBalanceTitle}
                        />
                        <Divider
                            className={classes.divider}
                            variant='fullWidth'
                        />
                        <BalanceTile
                            balance={stat?.currentBalance}
                            bottomDescription={stat?.currentBottomDescription}
                            title={stat?.currentBalanceTitle}
                        />
                    </Grid>
                ))
            }
        </Grid>
    );
};

export default WalletTotalBalanceTile;